import { render, staticRenderFns } from "./UrlList.vue?vue&type=template&id=9b712d28"
import script from "./UrlList.vue?vue&type=script&lang=js"
export * from "./UrlList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports